module.exports = __webpack_public_path__ + "static/media/colder.11c6b8cd.jpeg";